import * as actions from '../actions/quotationUtils';

const INITIAL_STATE = {
  loading: false,
  response: {},
  isError: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.REQUEST_PDF:
      return {
        ...state,
        loading: true,
        response: {},
        isError: false,
      };
    case actions.SUCCESS_PDF:
      return {
        ...state,
        loading: false,
        response: action.payload,
        isError: false,
      };
    case actions.FAILURE_PDF:
      return {
        ...state,
        loading: false,
        response: action.payload,
        isError: true,
      };
    case actions.RESET_PDF:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
